import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NitroNavBar } from 'nitro-components';
import * as localActions from './actions';

import styled from 'styled-components';

import * as ROUTES from '../../../routes/const';

import SettingsPanel from './components/SettingsPanel';

import Header from '../../../components/layouts/Header';

import Breakpoint from '../../../utils/breakpoints';

import { media } from 'style-utils';

import * as globalNotificationActions from '../../common/GlobalNotification/actions';

import {
  PAGE_HEADING,
  EMAIL_SETTINGS_HEADING,
  PORTAL_SETTINGS_HEADING,
} from './content';

const SettingsMobileContent = styled.div`
  padding: 20px 10px;

  ${media.mobileTablet`
       padding: 20px 0px;
    `}
`;
// TO BE REMOVED/MODIFIED based on API -- To be updated later - Mythreyi
const settingsPanelDetails = [
  {
    title: PORTAL_SETTINGS_HEADING,
    component: 'PortalNotification',
  },
  {
    title: EMAIL_SETTINGS_HEADING,
    component: 'EmailNotification',
  },
];

class NotificationSettings extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      pageTitleMobile: PAGE_HEADING,
      parentPageTitle: '',
      backURL: '',
      mobileActivePanel: -1,
      selectedComponent: settingsPanelDetails[0],
    };
    this.closeSubSettings = this.closeSubSettings.bind(this);
  }
  componentDidMount() {
    this.props.actions.localActions.getNotificationSettings();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.settings !== this.props.settings &&
      this.state.selectedComponent.component === 'PortalNotification'
    ) {
      this.props.actions.globalNotificationActions.getNotifications();
    }
  }

  goBack = () => {
    const { router } = this.context;
    router.goBack();
  };

  closeSubSettings = () => {
    this.setState({
      mobileActivePanel: -1,
      pageTitleMobile: PAGE_HEADING,
      parentPageTitle: '',
      backUrl: '',
      selectedComponent: {},
    });
  };

  setMobileHeader = (componentType, index) => {
    const component = settingsPanelDetails.filter((item, index) => {
      if (item.component === componentType) {
        return item;
      }
    });
    const title = component[0].title;

    this.setState({
      selectedComponent: component[0],
      parentPageTitle: PAGE_HEADING,
      pageTitleMobile: title,
      backUrl: ROUTES.NOTIFICATION_SETTINGS,
      mobileActivePanel: index,
    });
  };

  render() {
    return (
      <div>
        <Breakpoint name="mobileTablet">
          <SettingsMobileContent>
            <SettingsPanel
              details={settingsPanelDetails}
              data={this.props.settings}
              fetchingSettings={this.props.fetchingSettings}
              activePanel={this.state.mobileActivePanel}
              saveInfo={this.props.actions.localActions.setPortalSettings}
              onOptionChange={this.setMobileHeader}
              selectedComponent={this.state.selectedComponent}
            />
          </SettingsMobileContent>
        </Breakpoint>
        <Breakpoint name="desktop">
          <Header>
            <NitroNavBar
              label={PAGE_HEADING}
              action={this.goBack}
              inline
              header
            />
          </Header>
          <SettingsPanel
            details={settingsPanelDetails}
            data={this.props.settings}
            activePanel={
              this.state.mobileActivePanel >= 0
                ? this.state.mobileActivePanel
                : 0
            }
            fetchingSettings={this.props.fetchingSettings}
            saveInfo={this.props.actions.localActions.setPortalSettings}
            onOptionChange={this.setMobileHeader}
            selectedComponent={this.state.selectedComponent}
          />
        </Breakpoint>
      </div>
    );
  }
}

NotificationSettings.propTypes = {
  settings: PropTypes.array,
  fetchingSettings: PropTypes.bool,
  actions: PropTypes.object.isRequired,
};

NotificationSettings.contextTypes = {
  router: PropTypes.object,
};

const mapStateToProps = state => {
  const {
    settings,
    fetchingSettings,
  } = state.notification.notificationSettings;

  return {
    settings,
    fetchingSettings,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    globalNotificationActions: bindActionCreators(
      globalNotificationActions,
      dispatch
    ),
    localActions: bindActionCreators(localActions, dispatch),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationSettings);



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/NotificationSettings.js